// extracted by mini-css-extract-plugin
export var fadeIn = "_fu-1";
export var modalContent = "_fu-3";
export var overlay = "_fu-0";
export var popoverContent = "_fu-2";
export var results = "_fu-5";
export var searchInputWrapper = "_fu-4";